<template>
  <header>
    <h1>Peanuts</h1>
    <a href="index.html"><h2><span v-for="letter in title" :key="letter.id">{{letter}}</span></h2></a>
  </header>
  <aside v-if="drawResult === null">
    <div v-if="members.length < 1">
      <p>Bienvenue,
        <br/>Ceci est un générateur de Père noël Secret&#8239;!
        <br/>Vous pouvez créer une partie puis piocher au sort votre père noël secret, et ainsi passé le lien au joueur suivant pour que la partie se déroule.
        <br/>Amusez-vous bien&#8239;!</p>
    </div>
    <Form
      v-if="drawing !== true"
      :members="members"
      :drawing="drawing"
      @add="saveName"
    />
    <article v-if="drawing === true && !drawEnd">
      <p>
        C'est partie <span class="member"><MemberName :members="members" :id="player" /></span>&#8239;!
        <br />
        La partie {{ player === admin ? "à commencé." : "est en cours." }}
      </p>
      <p v-if="player === admin">
        Si vous pensez avoir oublier quelque chose,
        <button @click="drawReturn()">Clickez ici</button> et recommencez
      </p>
    </article>
  </aside>
  <aside v-else class="result">
    <DrawResult
      :members="members"
      :drawResult="drawResult"
      :drawEnd="drawEnd"
      :next="next"
      :player="player"
      @copy-link="copyLink"
    />
  </aside>
  <aside v-if="members.length > 0 && drawResult === null">
    <MemberList
      :members="members"
      :drawing="drawing"
      :player="player"
      @delete-member="deleteMember"
      @edit-member="editMember"
      @checked-member="checkedMember"
      @alert="newAlert"
    />
  </aside>
  <footer>
    <DrawButton
      v-if="played !== true"
      :members="members"
      :drawing="drawing"
      @draw-members="drawMembers"
      @launch-draw="drawLaunch"
    />
    <div>Made by <a href="https://www.fromager-florian.fr/" target="_blank">Florian Fromager</a> with vue and ☕ - <a href="https://gitlab.com/florian_fromager/peanuts">Link of the repo</a> - Typeface <a href="https://fraunces.undercase.xyz/" target="_blank">Fraunces</a> by <a href="https://undercase.xyz/" target="_blank">Undercase Type</a></div>
  </footer>
  <AlertBox v-if="alert" :alert="alert" />
  <Timer v-if="timer" :timer="timer" />
  <Sparkles :members="members" />
</template>

<script>
// JS MODULES IMPORTS

import { getParam, rewriteName, alertMsg, allSet, id } from "@/modules/modules.js";

// VUE COMPONENTS IMPORTS

import { ref } from "vue";
import Form from "@/components/Form.vue";
import MemberList from "@/components/MemberList.vue";
import MemberName from "@/components/MemberName.vue";
import DrawButton from "@/components/DrawButton.vue";
import DrawResult from "@/components/DrawResult.vue";
import AlertBox from "@/components/AlertBox.vue";
import Timer from "@/components/Timer.vue";
import Sparkles from "@/components/Sparkles.vue";

// EXPORTS

export default {
  name: "App",
  components: {
    Form,
    MemberList,
    MemberName,
    DrawButton,
    DrawResult,
    AlertBox,
    Timer,
    Sparkles,
  },
  computed: {
    title() {
      let title = "stunaeP",
        letters = title.split("");

      return letters;
    },
  },
  setup() {
    const href = window.location.href;
    const queryParams = new URLSearchParams(window.location.search);
    const localStorage = window.localStorage;

    let drewList = null;

    // INIT STORAGE

    if (!href.includes("id=") || !href.includes("Id=")) {
      localStorage.clear();
    }

    // INIT STORAGE END

    let storedJSON = null;
    let json = [];
    let player = ref("undefined");
    let admin = ref("undefined");
    let next = ref("undefined");

    // SET DRAW IF URL

    if (href.includes("id=") || href.includes("Id=")) {
      let drawParam = getParam("members");
      let drawJSON = JSON.parse(decodeURIComponent(drawParam));
      let drawLength = drawJSON.length;

      // SET ACTUAL PLAYER

      player.value = getParam("player");
      admin.value = getParam("a");

      if (localStorage.getItem("id") === null) {
        localStorage.setItem("id", getParam("id"));
      }

      // DRAW SUMMARY

      if (getParam("id") === localStorage.getItem("id")) {
        storedJSON = JSON.parse(localStorage.getItem("drawJSON"));

        if (storedJSON !== null) {
          let storedJSONRemaining = storedJSON.filter((t) => t.drew === false);
          let drawJSONRemaining = drawJSON.filter((t) => t.drew === false);
          storedJSON =
            storedJSONRemaining.length > drawJSONRemaining.length
              ? drawJSON
              : storedJSON;
        }
      }

      if (getParam("id") !== localStorage.getItem("id")) {
        localStorage.clear();
      }

      if (storedJSON !== null) {
        // drewList = storedJSON.filter((t) => t.drew === false);

        // AVOID CHEATING

        if (
          getParam("id") === localStorage.getItem("id") &&
          storedJSON.length !== drawLength
        ) {
          let newURL = href.substring(0, href.indexOf("?"));
          history.replaceState(null, null, newURL);
          document.location.reload();
        }
      }

      // console.log(`Les joueurs qui n'ont pas pioché`, drewList);
      // let drawnList = storedJSON.filter((t) => t.drawn === false);
      // console.log(`Les joueurs qui n'ont pas été pioché`, drawnList);

      json = storedJSON ? storedJSON : drawJSON;

      drewList = json.filter((t) => t.drew === false);

      if ( drewList.length === 3 ) {

        // console.log("Il ne reste que 3 joueurs", drewList);

          for (let i = 0; i < drewList.length; i++) {
            let el = drewList[i];
            const next = i === drewList.length -1 ? drewList[0] : drewList[i+1];

            el = json.find((t) => t.id === el.id);
            el.f = next.id;
          }

        // console.log("Nouveau JSON", json);

        localStorage.setItem("drawJSON", JSON.stringify(json));
        
      }

//       console.log(`L'id de cette partie est ${getParam("draw")}
// Le nombre de joueurs est de ${drawLength} joueurs
// Le joueur actuel est ${player.value}`);
    }

    // SET REFS
    let drawing = ref(href.includes("members=") || href.includes("Members=") ? true : false),
      members = ref(json),
      alert = ref(null),
      drawResult = ref(null),
      played = ref(false),
      timer = ref(null),
      drawEnd = ref(false);

    // COMPONENTS FUNCTIONS
    const saveName = (name, avoid) => {
      name = rewriteName(name);

      let playerId = id();

      if (members.value.length === 0) {
        player.value = playerId;
        admin.value = playerId;
      }

      let exist = false;
      members.value.map((t) => (t.name === name ? (exist = true) : null));

      if (exist === false) {

        members.value = [
          ...members.value,
          {
            name: name,
            av: avoid,
            drawn: false,
            drew: false,
            id: playerId,
          },
        ];
        
        if (members.value.length === 1) localStorage.setItem("player", playerId);
      }

      // AVOID SAME NAMES
      if (exist !== false) {
        alertMsg(
          alert,
          "Ce prénom existe déjà, essayez avec un nom de famille\u202F!"
        );
      }
    };

    const newAlert = (data) => {
      alertMsg(alert, data);
    };

    const editMember = (data) => {
      let result = members.value.filter((t) =>
        t.name === data.av ? (t) : null
      )[0];

      data.av = result === undefined ? null : result[Object.keys(result)[4]];

      members.value = members.value.map((t) => (t.id !== data.id ? t : data));
    };

    const checkedMember = (data) => {
      let members = document.querySelectorAll(".member");
      for (let i = 0; i < members.length; i++) {
        const el = members[i];
        el.classList.contains(`member-${data.name}`)
          ? el.classList.add("player")
          : el.classList.remove("player");
      }
      allSet(queryParams, "player", data.id);
      player.value = data.id;
      admin.value = data.id;
    };

    const deleteMember = (data) => {
      members.value = members.value.filter((t) => t.id !== data.id);
      let target = document.querySelector(`.member-${data.name}`);
      if (target.classList.contains("player")) {
        setTimeout(() => {
          document.querySelector(".member:first-child").classList.add("player");
        }, 100);
      }
    };

    const drawLaunch = () => {
      let player = localStorage.getItem("player"),
        membersJSON = JSON.stringify(members.value);

      allSet(queryParams, "id", id());
      allSet(queryParams, "a", admin.value);
      queryParams.set("player", player);
      queryParams.set("members", encodeURIComponent(membersJSON));
      history.replaceState(null, null, "?" + queryParams.toString());

      localStorage.setItem("drawJSON", membersJSON);

      drawing.value = true;
    };

    const drawReturn = () => {
      drawing.value = false;
    };

    // TIMER FUNCTIONS

    const drawTimer = (player, result, drewLgth) => {
      timer.value = "3";
      setTimeout(() => {
        timer.value = undefined;
      }, 999);
      setTimeout(() => {
        timer.value = "2";
      }, 1000);
      setTimeout(() => {
        timer.value = undefined;
      }, 1999);
      setTimeout(() => {
        timer.value = "1";
      }, 2000);
      setTimeout(() => {
        played.value = true;
        timer.value = undefined;
        drawResult.value = result;
        if (drewLgth === 0) {
          drawEnd.value = true;
        }

        history.replaceState(
          null,
          null,
          "?" + (drewLgth > 0 ? queryParams.toString() : "id")
        );
      }, 3000);
    };

    // DRAW TURN

    const drawMembers = () => {
      let drawParam = getParam("members");
      drawParam = localStorage.getItem("drawJSON")
        ? localStorage.getItem("drawJSON")
        : decodeURIComponent(drawParam);
      storedJSON = JSON.parse(drawParam);

      let player = localStorage.getItem("player");
      player = player !== null ? player : getParam("player");

      let playerJSON = storedJSON.filter((t) => t.id === player);
      playerJSON = playerJSON[0];

      console.log("playerFinal", playerJSON[Object.keys(playerJSON)[4]]);

      let newJSON = storedJSON.filter(
        (t) =>
          t.id !== player
          && t.drawn !== true
          && t.id !== playerJSON[Object.keys(playerJSON)[1]]
          && t.id !== playerJSON[Object.keys(playerJSON)[4]]
      );

      console.log("storedJSON",storedJSON);

      let drawResult = newJSON[Math.floor(Math.random() * newJSON.length)];

      // console.log(`${player} a pioché ${drawResult.name}`);

      members.value.filter((t) =>
        t.id === player ? (t.drew = drawResult.id) : null
      );

      // Validé le tirage du joeur pioché

      members.value.map((t) =>
        t.id === drawResult.id ? (t.drawn = true) : null
      );

      // Enregister les gens qu'il reste à à piocher

      drewList = members.value.filter((t) => t.drew === false);
      localStorage.setItem("drewList", JSON.stringify(drewList));

      let drewLgth = drewList.length;

      if (drewLgth > 0) {
        // Enregistrement de la liste des membres

        let membersJSON = JSON.stringify(members.value);

        queryParams.set("members", encodeURIComponent(membersJSON));
        localStorage.setItem("drawJSON", membersJSON);
        // Selectionner le joueur suivant

        let nextPlayer = drewList[Math.floor(Math.random() * drewList.length)];
        next.value = nextPlayer;

        // Enregister le joueur suivant

        allSet(queryParams, "player", nextPlayer ? nextPlayer.id : null);
      }

      // TIMER

      drawTimer(player, drawResult.id, drewLgth);
    };

    const copyLink = () => {
      let input = document.createElement("input"),
        url = window.location.href;

      document.body.appendChild(input);
      input.value = url;
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);

      newAlert("Le lien à été copié dans le presse-papier");
    };

    return {
      saveName,
      editMember,
      checkedMember,
      deleteMember,
      drawLaunch,
      drawReturn,
      drawMembers,
      members,
      player,
      admin,
      next,
      alertMsg,
      alert,
      newAlert,
      timer,
      played,
      drawTimer,
      drawing,
      drawResult,
      copyLink,
      drawEnd,
    };
  },
};
</script>

<style>
:root {
  --color:#131e4a;
  --second-color: #640000;
  --bg: antiquewhite;
}
::selection {
  background: none;
  color: #fff;
  text-shadow: 1px 1px #000;
}
#app {
  font-family: "Fraunces";
  font-variation-settings: "SOFT" 100, "wght" 15, "WONK" 0, "opsz" 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 2rem;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: end;
  color: var(--color);
  text-shadow: 1px 1px var(--bg);
}
html {
  background: var(--bg);
}
header,
footer {
  position: fixed;
  left: 50vw;
  transform: translate(-50%);
}
header {
  top: 0;
}
footer {
  bottom: 1rem;
}
footer div {
  margin-top: 1rem;
  font-size: .75rem;
}
footer div a {
  text-decoration: underline .4px solid var(--color);
}
h1 {
  display: none;
}
h2 {
  font-variation-settings: "SOFT" 100, "wght" 900, "WONK" 1, "opsz" 144;
  color: var(--color);
  border-bottom: 0.4px solid var(--color);
  margin: 0;
  font-size: 6rem;
  display: flex;
  flex-direction: row-reverse;
  text-transform: uppercase;
}
h2 span:not(:last-child) {
  margin-left: -1rem;
}
h2 span {
  text-shadow: 5px 3.5px #fff;
}
h2 span:nth-child(2n+2) {
  margin-top: .6rem;
}
a {
  color: var(--color);
  text-decoration: none;
}
aside {
  height: 90vh;
  width: 40vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1.6;
}
aside:only-of-type {
  width: 50vw;
  justify-content: space-evenly;
}
aside:only-of-type p {
  font-family: "Fraunces-Italic";
  /* margin-bottom: 3rem; */
}
aside:only-of-type.result {
  font-size: 3rem;
}
aside:only-of-type.result .member {
  font-family: "Fraunces";
}
caption {
  width: 100%;
  display: inline-block;
  font-size: 0.6rem;
  font-variation-settings: "SOFT" 100, "wght" 100, "WONK" 1, "opsz" 25;
}
label,
input {
  font-size: 2rem;
  font-variation-settings: "SOFT" 100, "wght" 15, "WONK" 0, "opsz" 0;
}
input {
  font-family: "Fraunces-Italic";
  border: none;
  border-bottom: 0.4px solid var(--color);
  background: none;
  display: inline-block;
  width: 140px;
  padding: 0 0.4rem;
  text-align: center;
  text-transform: capitalize;
}
input::first-letter {
  text-transform: uppercase;
}
textarea:focus,
input:focus {
  outline: none;
}

/* Reset Select */
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  outline: 0;
  box-shadow: none;
  border: 0;
  border-bottom: 0.4px solid var(--color);
  background: none;
  background-image: none;
  font-size: 2rem;
  color: var(--color);
  font-family: "Fraunces-Italic";
  font-variation-settings: "SOFT" 100, "wght" 15, "WONK" 0, "opsz" 0;
  text-align: center;

  flex: 1;
  padding: 0 0.5em;
  cursor: pointer;
  border-radius: 0;
}
/* Remove IE arrow */
select::-ms-expand {
  display: none;
}
/* Custom Select */
.select {
  position: relative;
  display: flex;
  width: 200px;
  height: 3rem;
  line-height: 3rem;
  background: none;
  overflow: hidden;
}
/* Arrow */
.select::after {
  content: "\25BC";
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 0.4rem;
  font-size: 1rem;
  background: none;
  cursor: pointer;
  pointer-events: none;
  -webkit-transition: 0.25s all ease;
  -o-transition: 0.25s all ease;
  transition: 0.25s all ease;
}
/* Transition */
.select:hover::after {
  color: #fff;
}
</style>
